<template>
    <div>
        <slot :fields="fields"></slot>
    </div>
</template>

<script>
    export default {
        name: 'SmartForm',

        props: {
            initialValues: { type: Object, required: true },
        },

        data() {
            return {
                fields: {
                    ...this.initialValues
                }
            };
        }
    }
</script>
